import type { ResolvedShellProduct } from 'models/purchaseFlowRevamp'

/**
 * The description shown at the top of the product drawer: the group's own, unless every option of the
 * group carries its own description, in which case the options explain themselves and the group
 * description stays on the catalogue card only.
 */
export const drawerDescription = (shell: ResolvedShellProduct | null | undefined): string | undefined => {
  if (!shell?.description) return undefined
  const variantsDescribeThemselves =
    shell.variants.length > 1 && shell.variants.every((variant) => !!variant.description)
  return variantsDescribeThemselves ? undefined : shell.description
}
